export const fillStringTemplate = (
  template: string,
  replacements: { [key: string]: string },
): string => {
  return template.replace(/\[\[([^\]]+)\]\]/g, (match, p1) => {
    return replacements[p1] || match;
  });
};
